// extracted by mini-css-extract-plugin
var _1 = "x6HDNZZx";
var _2 = "x6HDNZZx";
export { _1 as "lined-heading", _2 as "linedHeading" }
